var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasShowTips && _vm.tipsShow)?_c('div',{staticClass:"tipsWrapper"},[_c('div',{staticClass:"text"},[_vm._t("default"),(_vm.showCloseIcon)?_c('span',{staticClass:"font_family iconfont icon-guanbi tips-close-icon",on:{"click":_vm.closeTips}}):_vm._e()],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }